<template>
  <v-app>
    <v-content>
      <v-container color="grey" fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-form @submit.prevent="sendConfirmation">
              <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Reset hasła</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-toolbar-title>Karta Miejska</v-toolbar-title>
                </v-toolbar>

                <v-card-text>
                  <div
                    class="mt-1 text-xs-center"
                  >Wpisz adres e-mail, na który ma być wysłana wiadomość z linkiem do resetowania hasła:</div>

                  <v-text-field
                    prepend-icon="person"
                    v-model="login"
                    name="login"
                    label="Adres e-mail"
                    type="text"
                  ></v-text-field>
                </v-card-text>

                <v-card-actions>
                  <v-btn flat color="primary" @click="goBack">
                    <v-icon left>mdi-arrow-left-thick</v-icon>
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn type="submit" color="primary">Wyślij</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { authResource } from '@witkac/kartamiejska-resources';

import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Widok odyskiwania konta
// @group Auth
export default {
  mixins: [notificationsMixin],
  data() {
    return {
      login: undefined,
      showError: false,
      errorMessage: undefined
    };
  },
  methods: {
    // @vuese
    // Wysłanie emaila resetu hasła
    sendConfirmation() {
      authResource
        .resetPassword(this.login)
        .then(() => {
          this.notifySuccess('Wysłano wiadomość e-mail na podany adres.');
          this.$router.push({ name: 'login' });
        })
        .catch(err => this.notifyError('Nie udało się wysłać wiadomości.', [err.graphQLErrors[0].message]));
    },
    // @vuese
    // Powrót do poprzedniego widoku
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>
